import { Provider } from 'react-redux'
import { store } from '@/app/stores/store'

export const ReduxProvider = ({ children }: { children: React.ReactNode }) => (
  <Provider store={store}>{children}</Provider>
)
